// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --accentColor: #008ef4;
  --accentLightColor: rgba(0, 142, 244, 0.1);
  --textOnAcccentColor: white;
  --backgroundColor: #f5f5f5;
  --backgroudSecondaryColor: white;
  --textColor: black;
  --textSecondaryColor: gray;
  --errorColor: red;
  --grayColor: #0000007a;
  --grayLightColor: #0000002b;
  --grayOnAccentColor: #ffffffdb;
  --grayLightOnAccentColor: #ffffff3a;
}

.listTickets_listTickets__YRXQp .listTickets_ticketViewer__01u7f {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.listTickets_listTickets__YRXQp .listTickets_ticketViewer__01u7f .listTickets_label__FvHKO {
  color: var(--textSecondaryColor);
  font-weight: 500;
  margin-bottom: 5px;
}
.listTickets_listTickets__YRXQp .listTickets_milestone__fLd1T .listTickets_titlebar__nzb8r {
  display: flex;
  padding: 15px;
  cursor: pointer;
  font-weight: 600;
  border-bottom: 1px solid var(--backgroudSecondaryColor);
  margin-bottom: 10px;
}
.listTickets_listTickets__YRXQp .listTickets_milestone__fLd1T .listTickets_titlebar__nzb8r:hover {
  background-color: var(--backgroudSecondaryColor);
}
.listTickets_listTickets__YRXQp .listTickets_milestone__fLd1T .listTickets_tickets__CbWl1 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin: 0 15px;
}
.listTickets_listTickets__YRXQp .listTickets_milestone__fLd1T .listTickets_tickets__CbWl1 .listTickets_status__lM\\+fc {
  min-width: 300px;
}
.listTickets_listTickets__YRXQp .listTickets_milestone__fLd1T .listTickets_tickets__CbWl1 .listTickets_status__lM\\+fc .listTickets_statusTitle__zMzEj {
  font-weight: 500;
  margin-bottom: 10px;
}
.listTickets_listTickets__YRXQp .listTickets_milestone__fLd1T .listTickets_tickets__CbWl1 .listTickets_status__lM\\+fc .listTickets_ticketList__rCg0w {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.listTickets_listTickets__YRXQp .listTickets_milestone__fLd1T .listTickets_tickets__CbWl1 .listTickets_status__lM\\+fc .listTickets_ticketList__rCg0w .listTickets_ticket__kpSsF {
  background-color: var(--backgroudSecondaryColor);
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
}
.listTickets_listTickets__YRXQp .listTickets_milestone__fLd1T.listTickets_hidden__BE6qu .listTickets_tickets__CbWl1 {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/vars.scss","webpack://./src/pages/tickets/list/listTickets.module.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,0CAAA;EACA,2BAAA;EACA,0BAAA;EACA,gCAAA;EACA,kBAAA;EACA,0BAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;EACA,mCAAA;ACDF;;AATE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAYJ;AAVI;EACE,gCAAA;EACA,gBAAA;EACA,kBAAA;AAYN;AANI;EACE,aAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,uDAAA;EACA,mBAAA;AAQN;AANM;EACE,gDAAA;AAQR;AAJI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAMN;AAJM;EACE,gBAAA;AAMR;AAJQ;EACE,gBAAA;EACA,mBAAA;AAMV;AAHQ;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAKV;AAHU;EACE,gDAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAKZ;AAGM;EACE,aAAA;AADR","sourcesContent":["$mobileBP: 900px;\n\n:root {\n  --accentColor: #008ef4;\n  --accentLightColor: rgba(0, 142, 244, 0.1);\n  --textOnAcccentColor: white;\n  --backgroundColor: #f5f5f5;\n  --backgroudSecondaryColor: white;\n  --textColor: black;\n  --textSecondaryColor: gray;\n  --errorColor: red;\n  --grayColor: #0000007a;\n  --grayLightColor: #0000002b;\n  --grayOnAccentColor: #ffffffdb;\n  --grayLightOnAccentColor: #ffffff3a;\n}\n","@import '../../../styles/vars.scss';\n\n.listTickets {\n\n  .ticketViewer {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n\n    .label {\n      color: var(--textSecondaryColor);\n      font-weight: 500;\n      margin-bottom: 5px;\n    }\n  }\n\n  .milestone {\n\n    .titlebar {\n      display: flex;\n      padding: 15px;\n      cursor: pointer;\n      font-weight: 600;\n      border-bottom: 1px solid var(--backgroudSecondaryColor);\n      margin-bottom: 10px;\n\n      &:hover {\n        background-color: var(--backgroudSecondaryColor);\n      }\n    }\n\n    .tickets {\n      display: flex;\n      flex-direction: row;\n      gap: 20px;\n      margin: 0 15px;\n\n      .status {\n        min-width: 300px;\n\n        .statusTitle {\n          font-weight: 500;\n          margin-bottom: 10px;\n        }\n\n        .ticketList {\n          display: flex;\n          flex-direction: column;\n          gap: 10px;\n\n          .ticket {\n            background-color: var(--backgroudSecondaryColor);\n            padding: 10px;\n            border-radius: 5px;\n            cursor: pointer;\n          }\n        }\n      }\n\n    }\n\n    &.hidden {\n      .tickets {\n        display: none;\n      }\n\n    }\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listTickets": `listTickets_listTickets__YRXQp`,
	"ticketViewer": `listTickets_ticketViewer__01u7f`,
	"label": `listTickets_label__FvHKO`,
	"milestone": `listTickets_milestone__fLd1T`,
	"titlebar": `listTickets_titlebar__nzb8r`,
	"tickets": `listTickets_tickets__CbWl1`,
	"status": `listTickets_status__lM+fc`,
	"statusTitle": `listTickets_statusTitle__zMzEj`,
	"ticketList": `listTickets_ticketList__rCg0w`,
	"ticket": `listTickets_ticket__kpSsF`,
	"hidden": `listTickets_hidden__BE6qu`
};
export default ___CSS_LOADER_EXPORT___;
